// src/component/EcgContent.jsx

// 心电图展示组件

import React from 'react'
import { DEFAULT_ZOOM } from '../services/Macro';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

export default class EcgPanel extends React.Component {

    state = {
        /** 画布宽度(像素) */
        canvasWidth: 1120,
        /** 画布高度(像素) */
        canvasHeight: 300,
        /** 边框尺寸(像素) */
        frameSize: 20,
        zoomX: 1,
        zoomY: 1,
        step: 0,
        /** 最大步数 */
        max: 800,
        /** 滑块标注数组 */
        marks: {},
        samplePerPage: 0,
        samplePerJumpPage: 0,
        samplePerSecond: 0,
        samplePerStep: 1,
        sampleCount: 1,
    }

    componentDidMount() {
        this.props.onRef(this)
        this.callDrawFromChild()
    }

    handleChange = (step) => {
        console.log(`step:`, step)
        this.state.step = step
        this.setState({ step });
        this.draw()
    }

    prevSecond = () => {
        console.log(`Click prevSecond...`)
        this.state.step -= (this.state.samplePerSecond / this.state.samplePerStep)
        if (this.state.step < 0) this.state.step = 0
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
    }

    nextSecond = () => {
        console.log(`Click nextSecond...`)
        console.log(`old step:`, this.state.step)
        this.state.step += (this.state.samplePerSecond / this.state.samplePerStep)
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
    }

    prevPage = () => {
        console.log(`Click prevPage...`)
        this.state.step -= (this.state.samplePerJumpPage / this.state.samplePerStep)
        if (this.state.step < 0) this.state.step = 0
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
    }

    nextPage = () => {
        console.log(`Click nextPage...`)
        this.state.step += (this.state.samplePerJumpPage / this.state.samplePerStep)
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
    }

    firstPage = () => {
        console.log(`Click firstPage...`)
        this.state.step = 0
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
    }

    lastPage = () => {
        console.log(`Click lastPage...`)
        this.state.step = this.state.sampleCount / this.state.samplePerStep
        console.log(`new step:`, this.state.step)
        this.setState({ step: this.state.step });
        this.draw()
    }

    callDrawFromParent() {
        console.log(`来自父组件的调用`)
        if (this.props.samples) {
            console.log(`有数据1`)
            if (this.props.samples.data1) {
                console.log(`有数据2`)
                this.draw()
            }
            else {
                // 第一次调用时没有数据，需要等一下(0.01s)
                console.log(`没数据2`)
                setTimeout(() => {
                    this.callDrawFromParent()
                }, 10)
            }
        }
    }

    callDrawFromChild() {
        console.log(`来自子组件的调用`)
        this.draw()
    }

    draw() {
        const { zoomX, zoomY, frameSize, canvasWidth, canvasHeight } = this.state
        let canvas = document.getElementById('heartBeat')
        if (!canvas.getContext) return
        var ctx = canvas.getContext("2d")

        // 计算采样显示相关数据
        let baseY = 0
        let baseY1 = 0
        let samplePerPage = 0
        let sampleCount = 0
        let samplePerPixel = 1
        let samplePerStep = 0
        let durationPerStep = 0
        let startSample = 0
        let endSample = 0
        /** 列偏移量 */
        let colOffset = 0
        let xAnnotations = []
        if (this.props.samples) {
            if (this.props.samples.data1) {
                let rate = this.props.samples.data1.rate// 采样频率(个/秒)
                samplePerPixel = rate / 100
                baseY += 1024 / 200 * 10 * 4 * zoomY
                sampleCount = this.props.samples.data1.list.length
                console.log(`sampleCount:`, sampleCount)
                samplePerStep = sampleCount / this.state.max
                durationPerStep = samplePerStep / rate
                // 开始采样点
                startSample = Math.round(this.state.step * samplePerStep)
                colOffset = (startSample % (rate / 5)) * 5 / (rate / 5) * 4 * zoomX
                console.log(`startSample:`, startSample)
                console.log(`rate:`, rate)
                console.log(`colOffset:`, colOffset)
                for (let i = 0; i < 11; i++) {
                    const x = colOffset + i * 4 * zoomX * 25 + frameSize
                    const text = `${Math.round(startSample + i * rate)}`
                    // console.log(`x:`, x)
                    // console.log(`text:`, text)
                    xAnnotations.push({ x: x, text: text })
                }

                this.state.samplePerSecond = rate
                this.setState({ samplePerSecond: this.state.samplePerSecond })
                this.state.samplePerJumpPage = rate * Math.floor(10 / zoomX)// 一页为10秒数据
                this.setState({ samplePerJumpPage: this.state.samplePerJumpPage })
                this.state.samplePerStep = samplePerStep
                this.setState({ samplePerStep: this.state.samplePerStep })
                this.state.sampleCount = sampleCount
                this.setState({ sampleCount: this.state.sampleCount })
            }
        }
        // console.log(`xAnnotations:`, xAnnotations)
        // console.log(`sampleCount:`, sampleCount)
        // console.log(`samplePerStep:`, samplePerStep)
        // console.log(`durationPerStep:`, durationPerStep)
        // 计算滑块标尺
        this.state.marks = {}
        let stepTimes = this.state.max / 100
        for (let i = 0; i <= 10; i++) {
            let mark = i * 10 * stepTimes
            this.state.marks[mark] = Math.floor(mark * durationPerStep) + 's'
        }
        this.setState({ marks: this.state.marks })
        console.log(`this.state.marks:\n`, this.state.marks)

        // 绘制一块白色背景
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        // 绘制网格(红线)
        ctx.strokeStyle = 'red'
        // 横线
        for (let i = frameSize; i <= canvasHeight - frameSize; i += 4 * zoomY) {
            let x1 = frameSize, x2 = canvasWidth - frameSize
            let y1 = i
            let y2 = i

            let lw = 0
            if ((i - frameSize) / (frameSize * zoomY) === Math.ceil((canvasHeight - frameSize) / (frameSize * zoomY) / 2)) {
                lw = 0.4 * zoomX
                baseY += i
                baseY1 = i
            }
            else if ((i - frameSize) % (frameSize * zoomY) === 0) lw = 0.2 * zoomX
            else lw = 0.1 * zoomX

            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
        }
        // 竖线(随着取样点的移动而移动)
        for (let i = 0; i <= canvasWidth; i += 4 * zoomX) {
            let x1 = i + colOffset + 20
            let x2 = x1
            let y1 = frameSize
            let y2 = canvasHeight - frameSize

            let lw = 0
            // console.log(i % (frameSize * zoomX))
            if (i % (frameSize * zoomX) === 0) lw = 0.2 * zoomX
            else lw = 0.1 * zoomX

            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, lw)
            if (i > frameSize && i <= canvasWidth - frameSize) samplePerPage += 4 * zoomX * samplePerPixel
        }
        this.state.samplePerPage = samplePerPage
        this.setState({ samplePerPage: this.state.samplePerPage })
        for (let i = 0; i < xAnnotations.length; i++) {
            const annotation = xAnnotations[i];
            let x1 = annotation.x, x2 = annotation.x
            let y1 = canvasHeight - frameSize - 3
            let y2 = canvasHeight - frameSize + 8

            // 画一条竖线
            ctx.fillStyle = 'green'
            ctx.strokeStyle = 'green'
            this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)

            ctx.fillStyle = 'black'
            ctx.strokeStyle = 'black'
            ctx.fillText(annotation.text, annotation.x, canvasHeight - frameSize + 15)
        }
        // 心跳曲线(毫安/0.04s) 25
        let data = []
        if (this.props.samples) {
            ctx.fillStyle = 'black'
            ctx.strokeStyle = 'black'
            if (this.props.samples.data1) {
                // 终止采样点
                endSample = startSample + samplePerPage
                // 如果采样点结束位置已经超出最大采样数，则限制采样范围
                if (endSample > sampleCount) {
                    startSample = sampleCount - samplePerPage
                    endSample = startSample + samplePerPage
                }
                data = this.props.samples.data1.list.slice(startSample, endSample)
                // 麻省数据
                // for (let i = 0; i < data.length - 1; i++) {
                //     let x1 = i * zoomX / samplePerPixel + frameSize
                //     let y1 = baseY - data[i] * 10 * 4 * zoomY
                //     let x2 = (i + 1) * zoomX / samplePerPixel + frameSize
                //     let y2 = baseY - data[i + 1] * 10 * 4 * zoomY

                //     this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)
                // }
                console.log(`baseY: ${baseY}`)
                console.log(`baseY1: ${baseY1}`)
                console.log(`data.length: ${data.length}`)
                for (let i = 0; i < data.length - 1; i++) {
                    let x1 = i * zoomX / samplePerPixel + frameSize
                    // let y1 = baseY - data[i] * 10 * 4 * zoomY
                    let y1 = baseY1 - data[i] * 10 * 4 * zoomY
                    let x2 = (i + 1) * zoomX / samplePerPixel + frameSize
                    // let y2 = baseY - data[i + 1] * 10 * 4 * zoomY
                    let y2 = baseY1 - data[i + 1] * 10 * 4 * zoomY

                    // console.log(`start: x(${x1}), y(${y1})`)
                    this.drawLine(ctx, { x: x1, y: y1 }, { x: x2, y: y2 }, 0.5 * zoomX)
                }
            }
        }

        // 遮住左边和右边
        ctx.fillStyle = "rgb(255,255,255)";
        ctx.fillRect(0, 0, frameSize - 1, canvasHeight);
        ctx.fillRect(canvasWidth - (frameSize - 1), 0, frameSize - 1, canvasHeight);
    }

    drawLine = (ctx, p1, p2, lw) => {
        ctx.beginPath()
        ctx.moveTo(p1.x, p1.y)
        ctx.lineTo(p2.x, p2.y)
        ctx.closePath()
        ctx.lineWidth = lw
        ctx.stroke()
    }

    onZoomXChange = (event) => {
        this.state.zoomX = parseInt(event.target.text)
        this.setState({ zoomX: this.state.zoomX })
        this.draw(this.state.zoomX)
    }

    onZoomYChange = (event) => {
        this.state.zoomY = parseInt(event.target.text)
        this.setState({ zoomY: this.state.zoomY })
        this.draw(this.state.zoomY)
    }

    render() {
        // let t = this.props.trans
        const { step } = this.state;
        return (
            < div className="panel-body" >
                {/** 画布控制区 */}
                < div id="canvasCtrl" >
                    <div className="btn-group">
                        <button style={{ width: '80px' }} type="button"
                            className="mb-xs mt-xs mr-xs btn btn-default dropdown-toggle"
                            data-toggle="dropdown"> {this.state.zoomX} <span className="caret"></span></button>
                        <ul className="dropdown-menu" role="menu">
                            {DEFAULT_ZOOM.map((item, index) => (
                                <li key={index}><a onClick={this.onZoomXChange}>{item}</a></li>
                            ))}
                        </ul>
                    </div>
                    <label>缩放X .</label>
                    <div className="btn-group">
                        <button style={{ width: '80px' }} type="button"
                            className="mb-xs mt-xs mr-xs btn btn-default dropdown-toggle"
                            data-toggle="dropdown"> {this.state.zoomY} <span className="caret"></span></button>
                        <ul className="dropdown-menu" role="menu">
                            {DEFAULT_ZOOM.map((item, index) => (
                                <li key={index}><a onClick={this.onZoomYChange}>{item}</a></li>
                            ))}
                        </ul>
                    </div>
                    <label>缩放Y .</label>
                </div >
                <div className="heartBeat">
                    <canvas id="heartBeat" width={this.state.canvasWidth} height={this.state.canvasHeight} />
                </div>
                <div className="row">
                    <div className="col-md-2">
                        <ul className="pagination">
                            <li key="first_page">
                                <a href="javascript:void(0)" onClick={this.firstPage}>
                                    |<span className="fa fa-chevron-left"></span>
                                </a>
                            </li>
                            <li key="prev_page">
                                <a href="javascript:void(0)" onClick={this.prevPage}>
                                    P<span className="fa fa-chevron-left"></span>
                                </a>
                            </li>
                            <li key="prev_second">
                                <a href="javascript:void(0)" onClick={this.prevSecond}>
                                    S<span className="fa fa-chevron-left"></span>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-8">
                        <Slider
                            max={this.state.max}
                            marks={this.state.marks}
                            value={Math.round(step)}
                            onChange={this.handleChange} />
                    </div>
                    <div className="col-md-2">
                        <ul className="pagination">
                            <li key="next_second">
                                <a href="javascript:void(0)" onClick={this.nextSecond}>
                                    <span className="fa fa-chevron-right">S</span>
                                </a>
                            </li>
                            <li key="next_page">
                                <a href="javascript:void(0)" onClick={this.nextPage}>
                                    <span className="fa fa-chevron-right">P</span>
                                </a>
                            </li>
                            <li key="last_page">
                                <a href="javascript:void(0)" onClick={this.lastPage}>
                                    <span className="fa fa-chevron-right">|</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div >
        )
    }
}